import React from 'react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://customer-assets.emergentagent.com/job_e27ebe9b-30d6-413b-8ace-1878381002bd/artifacts/5ip4s9xa_WhatsApp%20Image%202026-03-03%20at%2009.28.46%20%282%29.jpeg" 
              alt="ATW Against the Wind Logo" 
              className="h-16 w-auto object-contain"
            />
          </div>
          
          {/* Navigation Menu */}
          <div className="flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-gray-700 hover:text-brand-blue transition-colors font-medium"
            >
              Reviews
            </button>
          </div>
          
          {/* Emergent Badge */}
          <a
            href="https://app.emergent.sh/?utm_source=emergent-badge"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <img
              src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4"
              alt="Emergent"
              className="h-6 w-6"
            />
            <span className="text-sm font-medium">Made with Emergent</span>
          </a>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} ATW Against the Wind Moving Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;